<template>
  <div>
    <div class="w-full  ">
      <!-- component -->
      <div
        class="px-2 py-5 md:p-5 lg:w-2/4 mx-auto text-center bg-white bg-opacity-25 rounded-lg"
      >
        <div
          class="text-custom text-xl lg:text-2xl mb-5 leading-none font-medium"
        >
          New Ticket
        </div>
        <div class="mt-2 text-left md:text-right">
          <div class="flex flex-col md:flex-row pb-1 md:mb-2">
            <div class="w-auto md:text-lg font-medium mx-2 mt-3 text-white">
              Title
            </div>
            <div class="md:w-4/5 md:ml-auto mx-2">
              <div class="md:my-2 p-1">
                <input
                  type="text"
                  v-model="ticketData.title"
                  class="focus:outline-none w-full text-gray-900 bg-white py-2 md:py-3 bg-opacity-75 border rounded-lg px-5"
                  placeholder="Enter title here"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-col md:flex-row pb-1 md:mb-2">
            <div class="w-auto md:text-lg font-medium mx-2 mt-3 text-white">
              Details
            </div>
            <div class="md:w-4/5 md:ml-auto mx-2">
              <div class="md:my-2 p-1">
                <textarea
                  v-model="ticketData.detail"
                  rows="5"
                  class="focus:outline-none w-full text-gray-900 bg-white py-2 md:py-3 bg-opacity-75 border rounded-lg px-5"
                  placeholder="Enter message"
                ></textarea>
              </div>
            </div>
          </div>

          <div class="md:w-4/5 ml-auto flex flex-col md:flex-row">
            <button
              class="btn my-2 md:my-0 min-w-12 py-1 text-white font-medium duration-200 ease-in-out"
              @click="createTicket"
            >
              Send Ticket
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- Facebook Pixel Code -->
<script>
!(function(f, b, e, v, n, t, s) {
  if (f.fbq) return;
  n = f.fbq = function() {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = "2.0";
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(
  window,
  document,
  "script",
  "https://connect.facebook.net/en_US/fbevents.js"
);
// eslint-disable-next-line no-undef
fbq("init", "261976718326827");
// eslint-disable-next-line no-undef
fbq("track", "PageView");
</script>
<noscript><img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=261976718326827&ev=PageView&noscript=1"
/></noscript>
<!-- End Facebook Pixel Code -->
<script>
// @ is an alias to /src
// import Layout from "@/views/admin/Layout.vue";
import TicketService from "@/providers/tickets";
import firebase from "firebase";

export default {
  name: "NewTicket",
  metaInfo: {
    title: "Spyows",
    titleTemplate: "%s | NewTicket",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  /* components: {
    Layout
  }, */
  data() {
    return {
      userData: null,
      referral: "spyowsbdsjdabasjhdgyuad/referral?/sigma101",
      ticketData: {
        title: "",
        detail: ""
      }
    };
  },
  mounted() {
    let user = firebase.auth().currentUser;
    firebase
      .database()
      .ref(`users/${user.uid}`)
      .on("value", snapshot => {
        this.userData = snapshot.val();
      });
  },
  methods: {
    async createTicket() {
      try {
        await TicketService.createTicket(this.userData.uid, this.ticketData);
        this.$vToastify.success(
          "Ticket has been created successfully",
          "Ticket creation success"
        );
        this.$router.back();
      } catch (err) {
        this.$vToastify.error("Failed to Create ticket");
      }
    }
  }
};
</script>

<style lang="postcss" scoped>
table thead tr th {
  @apply text-left py-5 px-4 uppercase font-semibold text-sm;
}
table tbody tr {
  @apply border-b border-gray-300;
}
table tbody tr td {
  @apply text-left py-3 px-4 border-r border-gray-300;
}
table tbody tr td:last-child,
table tbody tr:last-child {
  @apply border-none;
}
</style>
